import styled, { css } from 'styled-components';
import { StyledButton } from 'components/ui/Button/Button';
import { mediaMSmMax } from '../../helpers/breakpoints';
import PasswordInput from '../forms/PasswordInput';
import PhoneInputComponent from '../forms/PhoneInput/PhoneInput';

export const StyledPassword = styled(PasswordInput)`
  input {
    border: 1px solid rgba(142, 150, 151, 0.5) !important;
  }
`;

export const AuthWrapper = styled.div`
  ${StyledButton} {
    display: flex;
    align-items: center;
  }

  [class*='Input_error'] {
    input {
      border-color: #bc350a !important;
    }
  }

  [class*='Input_input_'] {
    height: 50px;
    outline: none;
  }
`;

export const StyledPhone = styled(PhoneInputComponent)`
  //margin-bottom: 20px;
  max-width: 500px;

  .PhoneInputCountry span {
    font-weight: 500;
  }

  .ControlError-list {
    padding-top: 5px;
  }
`;

export const InputWrapper = styled.div<{ hidePadding?: boolean }>`


  ${({ hidePadding }) =>
    !hidePadding &&
    css`
      margin-bottom: 20px;
      max-width: 500px;
    `}



  &.birthDay {

        .selectInputWrap {
              position: relative;
        }

        select {
              border: 1px solid rgba(142, 150, 151, 0.5) !important;
              outline: none;
              &.is-invalid {
                border-color: #bc350a !important;
              }
        }
        }
        .birthday-mobile-date-input {
              border: 1px solid rgba(142, 150, 151, 0.5) !important;
              &.is-invalid {
                    border-color: #bc350a !important;
              }
        }
  }


  .ControlError-list {
      padding-top: 5px;
  }

  &.checkBox {

    input {
      border: 1px solid rgba(142, 150, 151, 0.5) !important;
    }

  .smallText {
    line-height: 130%;
    font-size: 12px;
  }

    label span {
      color: #5E696A;

      ${mediaMSmMax} {
        font-size: 12px;

        a {
          color: #0751C2 !important;
        }
      }
    }



`;
